import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
import AdminAuthorize from "@/helper/AdminAuthorize";
import { getModule } from "vuex-module-decorators";
import { Auth } from "@/store/modules/AuthModule";

const AuthModule = getModule(Auth, store);

Vue.use(VueRouter);

function lazyLoad(view: string): any {
  return () => import(`@/views/${view}.vue`);
}

function lazyLoadAdmin(view: string): any {
  return () => import(`@/views/admin/${view}.vue`);
}

const routes = [
  {
    path: "/login",
    name: "Login",
    component: lazyLoad("Login")
  },
  {
    path: "/",
    name: "Home",
    component: lazyLoad("Home")
  },
  {
    path: "/index.html",
    name: "Home",
    alias: "/",
    component: lazyLoad("Home")
  },
  {
    path: "/page/:id",
    name: "Page",
    props: true,
    component: lazyLoad("Page")
  },
  {
    path: "/PostNewAd",
    name: "PagePostEditor",
    component: lazyLoad("PagePostEditor")
  },
  {
    path: "/SearchForm",
    name: "SearchForm",
    component: lazyLoad("PageSearchForm")
  },
  {
    path: "/Search/:date?/:categoryId?/:stateId?/:searchText?",
    name: "PageSearch",
    component: lazyLoad("PageSearch"),
    props: true
  },
  {
    path: "/ad/:adId?",
    name: "PageShowItem",
    props: true,
    component: lazyLoad("PageShowItem")
  },
  {
    path: "/401",
    component: lazyLoad("PageUnauthorize"),
    name: "PageUnauthorize"
  },
  {
    path: "/404",
    component: lazyLoad("PageNotFound"),
    name: "PageNotFound"
  },
  {
    path: "/maintenance",
    name: "Maintenance",
    component: lazyLoad("Maintenance")
  },
  {
    path: "/authorize",
    name: "Authorize",
    component: lazyLoad("Authorize")
  },
  {
    path: "/expired",
    name: "Session",
    component: lazyLoad("PageSessionExpired")
  },
  {
    path: "/login",
    name: "login",
    component: lazyLoad("login")
  },
  {
    path: "/admin",
    name: "Admin",
    component: lazyLoadAdmin("Admin"),
    //beforeEnter: AdminAuthorize,
    redirect: "/admin",
    children: [
      {
        path: "",
        component: lazyLoadAdmin("Admin")
      }
    ]
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to: any) {
    if (to.hash) {
      const el: any = (document && document.querySelector(to.hash)) as any; // hack, since Element doesn't have offsetTop
      if(el){
        return window.scrollTo({
          top: el.offsetTop || 0,
          behavior: "smooth"
        });
      }
      
    }
    return { x: 0, y: 0 };
    
  }
});

router.beforeEach(async (to, from, next) => {
  if (AuthModule.currentUser == null) {
    await AuthModule.checkUserAuthentication();
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (AuthModule.isAuthenticated === false) {
      next({
        path: "/login",
        query: { redirect: to.fullPath }
      });
    } else {
      const { redirect } = to.query;
      if (redirect) {
        next({ path: redirect as string });
      } else {
        next();
      }
    }
  } else if (to.matched.length === 0) {
    next({
      path: "/404"
    });
  } else {
    if (AuthModule.isAuthenticated) {
      const { redirect } = to.query;
      if (redirect) {
        next({ path: redirect as string });
      } else {
        next();
      }
    } else {
      next();
    }
  }
});
router.afterEach(route => {});

export default router;
